import { useGlossaryStore } from '../store'; // Adjust path as necessary
import { computed } from 'vue';

/**
 * Provides access to glossary state and actions.
 */
export function useGlossary() {
  const glossaryStore = useGlossaryStore();

  // Correctly named state based on store definition
  const isGlossaryOpen = computed(() => glossaryStore.isOpen);
  const glossaryTerm = computed(() => glossaryStore.currentTerm);

  const openGlossary = (term?: string) => {
    glossaryStore.openGlossary(term);
  };

  const closeGlossary = () => {
    glossaryStore.closeGlossary();
  };

  // Add toggle function if desired
  const toggleGlossary = (term?: string) => {
    if (glossaryStore.isOpen) {
      closeGlossary();
    } else {
      openGlossary(term);
    }
  };

  return {
    isGlossaryOpen,
    glossaryTerm,
    openGlossary,
    closeGlossary,
    toggleGlossary, // Now defined here
  };
} 